module.exports = __webpack_public_path__ + "img/blue_128.b4cb3739.png";